<div class="dashboard-background">
  <div class="container dashboard">
    <div class="row">
      <div class="col-8">
        <!-- Inactive - Pending Purchase-->
        <ng-container *ngIf="store.inactiveCertifications$ | async; let inactiveCertifications">
          <ng-container *ngIf="inactiveCertifications.length">
            <mat-card class="mt-4">
              <mat-card-header class="card-header" style="margin: -15px -15px 20px -15px">
                <mat-card-title class="mx-0">
                  <h5 [translate]="'Dashboard.InactiveCertification.Title'"></h5>
                </mat-card-title>
              </mat-card-header>

              <app-certification-widget
                *ngFor="let certification of inactiveCertifications; let i = index"
                [certification]="certification"
                [isLast]="i === inactiveCertifications.length - 1"
              ></app-certification-widget>
            </mat-card>
          </ng-container>
        </ng-container>


        <!-- Active - In Progress -->
        <ng-container *ngIf="store.activeCertifications$ | async; let activeCertifications">
          <ng-container *ngIf="activeCertifications.length">
            <mat-card class="mt-4">
              <mat-card-header class="card-header" style="margin: -15px -15px 20px -15px">
                <mat-card-title class="mx-0">
                  <h5 [translate]="'Dashboard.ActiveCertification.Title'"></h5>
                </mat-card-title>
              </mat-card-header>

              <app-certification-widget
                *ngFor="let certification of activeCertifications; let i = index"
                [certification]="certification"
                [isLast]="i === activeCertifications.length - 1"
              ></app-certification-widget>
            </mat-card>
          </ng-container>
        </ng-container>

        <!-- Pending Review -->
        <ng-container *ngIf="store.pendingCertifications$ | async; let pendingCertifications">
          <ng-container *ngIf="pendingCertifications.length">
            <mat-card class="mt-4">
              <mat-card-header class="card-header" style="margin: -15px -15px 20px -15px">
                <mat-card-title class="mx-0">
                  <h5 [translate]="'Dashboard.PendingCertification.Title'"></h5>
                </mat-card-title>
              </mat-card-header>

              <app-certification-widget
                *ngFor="let certification of pendingCertifications; let i = index"
                [certification]="certification"
                [isLast]="i === pendingCertifications.length - 1"
              ></app-certification-widget>
            </mat-card>
          </ng-container>
        </ng-container>

        <!-- Completed -->
        <ng-container *ngIf="store.completedCertifications$ | async; let completedCertifications">
          <ng-container *ngIf="completedCertifications.length">
            <mat-card class="mt-4">
              <mat-card-header class="card-header" style="margin: -15px -15px 20px -15px">
                <mat-card-title class="mx-0">
                  <h5 [translate]="'Dashboard.CompletedCertification.Title'"></h5>
                </mat-card-title>
              </mat-card-header>

              <app-certification-widget
                *ngFor="let certification of completedCertifications; let i = index"
                [certification]="certification"
                [isLast]="i === completedCertifications.length - 1"
              ></app-certification-widget>
            </mat-card>
          </ng-container>
        </ng-container>

        <!-- Expired -->
        <ng-container *ngIf="store.expiredCertifications$ | async; let expiredCertifications">
          <ng-container *ngIf="expiredCertifications.length">
            <mat-card class="mt-4">
              <mat-card-header class="card-header" style="margin: -15px -15px 20px -15px">
                <mat-card-title class="mx-0">
                  <h5 class="text-secondary" [translate]="'Dashboard.ExpiredCertification.Title'"></h5>
                </mat-card-title>
              </mat-card-header>

              <app-certification-widget
                *ngFor="let certification of expiredCertifications; let i = index"
                [certification]="certification"
                [isLast]="i === expiredCertifications.length - 1"
              ></app-certification-widget>
            </mat-card>
          </ng-container>
        </ng-container>

        <!-- Add a little space at the bottom -->
        <div style="height: 200px"></div>
      </div>

      <!-- Sidebar -->
      <div class="col-4">
        <div>
          <!-- Important Information -->
          <!--<div class="row">
            <div class="col">
              <a class="btn btn-primary btn-block mt-3" role="button" [routerLink]="['/register/certification']">
                {{ 'Dashboard.AddCertification' | translate }}
              </a>
            </div>
          </div>-->
          <div class="row" style="margin-top: 10px;">
            <div class="col">
              <div class="card">
                <div class="card-header">
                  <h5>{{ 'Dashboard.Information.Title' | translate }}</h5>
                </div>
                <div class="card-body">
                  <ul class="">
                    <!-- links -->
                    <li>
                      <a
                        href="assets/pdf/{{ 'Dashboard.Information.SampleCertificateFileName' | translate }}"
                        target="_blank"
                        translate="Dashboard.Information.SampleCertificate"
                      ></a>
                    </li>
                    <li>
                      <a href="/assets/pdf/{{ 'Dashboard.ContestFile' | translate }}" target="_blank">{{
                        'Dashboard.Contest' | translate
                      }}</a>
                    </li>
                    <li>
                      <a href="/assets/pdf/{{ 'Dashboard.Information.UnderstandingYourResultsFile' | translate }}" target="_blank">{{
                        'Dashboard.Information.UnderstandingYourResults' | translate
                      }}</a>
                    </li>
                    <li>
                      <span class="link" (click)="commonDialogService.showTerms()" translate="Dashboard.Information.Terms"></span>
                    </li>
                    <li>
                      <span class="link" (click)="commonDialogService.showContact()" translate="Dashboard.Information.ContactUs"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Show Sample test if there are any -->
          <ng-container *ngIf="store.sampleTests$ | async; let sampleTests">
            <ng-container *ngIf="sampleTests.length">
              <div class="row">
                <div class="col">
                  <div class="card">
                    <div class="card-header">
                      <h5>
                        {{ 'Dashboard.Information.SampleTest' | translate }}
                      </h5>
                    </div>
                    <div class="card-body">
                      <ul>
                        <li *ngFor="let test of sampleTests">
                          <a [routerLink]="['/exam/', test.id]">{{ test.title }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
